import { useGetOne } from "react-admin";
import { AutovioCalendarEvent, isPracticalExam } from "../model/autovioCalendarEvents";
import { Student } from "../providers/studentsProvider";
import { DrivingLicenseClass } from "../model/DrivingLicenseClass";

export function usePracticalExamDrivingLicenseClass(
  event: AutovioCalendarEvent | undefined,
): DrivingLicenseClass | undefined {
  const { data: student } = useGetOne<Student>(
    "students",
    { id: isPracticalExam(event) ? event.student.uid : "" },
    { enabled: isPracticalExam(event) },
  );
  if (student) {
    return student.bookedTrainingsById[event?.student.bookedTrainingId]?.drivingLicenseClass;
  }
  return undefined;
}
